import React, { useState, useEffect } from 'react';
import { client } from '../components/client';
import portrait from '../img/portfolio/portrait.jpg';
import blackwhite from '../img/portfolio/bird.jpg';
import city from '../img/portfolio/ribs.jpg';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import About from './About'
import Works from './Works'
import Contact from './Contact'
import { transition1 } from '../transitions';
import Hero from '../components/Hero'
import header from '../img/header/header.jpg'

const Portfolio = () => {

  const [portraits, setPortraits] = useState([]);
  


  useEffect(() => {
    const query = '*[_type == "portraits"]';

    client.fetch(query).then((data) => {
      setPortraits(data);
    });

    console.log(portraits)
  }, []);

 

  return (

    
    <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      transition={transition1}
      className='section overflow-auto'
    >
      <Hero/>
      <div className='container mx-auto h-full relative lg:mb-0 mb-64'>
        <div className='flex flex-col lg:flex-row h-full items-center justify-start gap-x-4 lg:gap-x-24 text-center lg:text-left pt-24 lg:pt-36 pb-8'>
          <motion.div
            initial={{ opacity: 0, y: '-80%' }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: '-80%' }}
            transition={transition1}
            className='flex mt-6 flex-col lg:items-start'
          >
            <h1 className='h1'>Portfolio</h1>
            <p className='mb-12 max-w-sm'>
              Hi, I'm Soroush -<br /> a passionate street photographer located in Toronto, with a love for capturing beauty in ordinary, day-to-day things. <br/>Thank you for visiting my portfolio!
            </p>
            <Link to={'/works'} className='btn mb-[30px] mx-auto lg:mx-0 cursor-pointer hover:scale-110'>
              See My Work
            </Link>

          </motion.div>
          <div className='grid grid-cols-1 lg:grid-cols-2 gap-4 mt-5 w-full'>
            <div className='mb-5 lg:mb-0 w-full lg:w-auto'>
              <div className='flex max-w-full mb-5 lg:max-w-[320px] h-[187px] lg:h-[220px] overflow-hidden'>
                <img
                  className='w-full h-full object-cover hover:scale-110 transition-all duration-500'
                  src={blackwhite}
                  alt=''
                />
                <h1 className='h1 text-4xl lg:text-5xl p-2 mt-4 lg:mt-0 lg:ml-7 hover:scale-110 transition-all duration-500'>Black <br /> <p className='bg-yellow-400 rounded-full w-1/2 ml-5 lg:w-2/5 lg:ml-7'>&</p> White</h1>
              </div>
              <div className='flex max-w-full mb-5 lg:max-w-[320px] h-[187px] lg:h-[220px] overflow-hidden'>
                <h1 className='h1 text-2xl lg:text-4xl p-3 mt-14 hover:scale-110 transition-all duration-500'>Portraits</h1>
                <img
                  className='w-full h-full object-cover hover:scale-110 transition-all duration-500'
                  src={portrait}
                  alt=''
                />
              </div>
              
              <div className='lg:hidden mb-5 w-full lg:w-auto '>
                <div className='flex max-w-full mb-5 lg:max-w-[320px] h-[187px] lg:h-[220px] overflow-hidden'>
                  <img
                    className='w-full h-full object-cover hover:scale-110 transition-all duration-500'
                    src={city}
                    alt=''
                  />
                  <h1 className='h1 text-4xl lg:text-5xl p-2 mt-12 hover:scale-110 transition-all duration-500'>And more...</h1>
                </div>
              </div>
            </div>
            
            <div className='max-w-full lg:max-w-[320px] lg:h-[220px] lg:block hidden'>
              <h1 className='h1 text-5xl p-2 mt-4 hover:scale-110 transition-all duration-500'>City</h1>
              <img
                className='w-full h-full object-cover hover:scale-105 transition-all duration-500'
                src={city}
                alt=''
              />
            </div>
            
            
          </div>
        </div>
      </div>
      <div className='mb-14'>.</div>
      <Works/>
      <Contact/>

    </motion.section>
  );
};

export default Portfolio;